import { getPermissions, getSessionBrand, isBarberSessionView, useSession } from '../../infra/session';
import { canUserViewEngage } from '../../../app/common/helpers/users';
import { useFeatureFlags } from '../../infra/feature-flags';
import { useBarberType } from '../../barber/barber-type/use-barber-type';
export var canBrandUseEngage = function (session) {
    var brand = getSessionBrand(session);
    return brand === null || brand === void 0 ? void 0 : brand.campaignsEnabled;
};
export var canUserSeeEngage = function (_a) {
    var permissions = _a.permissions, flags = _a.flags, engageEnabledForBrand = _a.engageEnabledForBrand, isBarberView = _a.isBarberView, barberType = _a.barberType;
    var hasPermission = canUserViewEngage(permissions);
    // engageForBarbers controls access for indy (studio) barbers
    // engageForChairRenters controls access for both rental and commission barbers (chair renters)
    var isIndyBarberWithEngage = barberType === 'studio' && flags.engageForBarbers;
    var isNonIndyBarberWithEngage = barberType !== 'studio' && flags.engageForChairRenters;
    var barberEngageEnabled = isIndyBarberWithEngage || isNonIndyBarberWithEngage;
    return engageEnabledForBrand && hasPermission && (!isBarberView || barberEngageEnabled);
};
export var useCanUserSeeEngage = function () {
    var session = useSession().data;
    var flags = useFeatureFlags();
    var barberType = useBarberType();
    var permissions = getPermissions(session);
    var engageEnabledForBrand = canBrandUseEngage(session);
    var isBarberView = isBarberSessionView(session.view);
    return canUserSeeEngage({
        flags: flags,
        permissions: permissions,
        engageEnabledForBrand: engageEnabledForBrand,
        isBarberView: isBarberView,
        barberType: barberType,
    });
};
